// The WorkOS organization the app signs into, passed to the router's /auth/login
// (utilities/routerLogin.ts). The app no longer talks to AuthKit itself: every
// sign-in starts at the router (nobgp/nobgp-router#339).
export const workosOrganizationId = import.meta.env.VITE_WORKOS_ORGANIZATION_ID
